import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Info, RotateCw } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui-kit/button';
import { CardTitle } from '@/components/ui-kit/card';

import { KBDocumentContent } from './components/kb-document-content';
import { KBDocumentInfo } from './components/kb-document-info';
import { ReembedKb } from '../components/reembed-kb';
import { EmbedStatus } from '../components/kb-embed-status/kb-embed-status';
import { KB, EmbeddedStatus } from '@/modules/gpt-chats/models/kb';
import { getKBName } from '@/modules/gpt-chats/components/knowledge-base/utils';
import { useTranslation } from 'react-i18next';

export const KBDocumentPage = ({ kb }: { kb?: KB; onBack?: () => void; folderName?: string }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const pathname = location.pathname;
  const documentId = kb?.id || pathname?.split('/').pop() || '';
  const [isReEmbedOpen, setIsReEmbedOpen] = useState(false);
  const [isInfoOpen, setIsInfoOpen] = useState(false);

  let documentTitle = '';

  if (kb) {
    documentTitle = getKBName(kb, t);
  }

  const [overrideStatus, setOverrideStatus] = useState<EmbeddedStatus | null>(null);

  useEffect(() => {
    setOverrideStatus(null);
  }, [kb?.embad_status]);

  const embedstatus = overrideStatus || kb?.embad_status || EmbeddedStatus.COMPLETED;

  return (
    <div className="flex flex-col gap-4">
      {/* <Breadcrumb className="hidden md:flex">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/ai/knowledge-base" className="text-foreground hover:text-foreground">
                {BREADCRUMB_CUSTOM_TITLES['/ai/knowledge-base'] || 'Knowledge Base'}
              </Link>
            </BreadcrumbLink>
          </BreadcrumbItem>

          <BreadcrumbSeparator />

          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <span
                className="cursor-pointer text-foreground hover:text-foreground"
                onClick={() => {
                  if (onBack) onBack();
                }}
              >
                {folderName ||
                  BREADCRUMB_CUSTOM_TITLES[`/ai/knowledge-base/${documentId}`] ||
                  'Folder'}
              </span>
            </BreadcrumbLink>
          </BreadcrumbItem>

          <BreadcrumbSeparator />

          <BreadcrumbItem>
            <BreadcrumbPage className="text-low-emphasis">{documentTitle}</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb> */}
      <div
        className={cn(
          'flex flex-col justify-between gap-3 transition-all duration-300 ease-in-out md:flex-row md:items-center md:gap-0',
          isInfoOpen ? 'w-full xl:w-[75%] xl:pr-4' : 'w-full'
        )}
      >
        <div className="flex w-full flex-col gap-2 overflow-hidden md:w-auto md:flex-row md:items-center md:gap-3">
          <CardTitle className="w-full truncate text-xl md:w-auto" title={documentTitle}>
            {documentTitle}
          </CardTitle>
          <EmbedStatus status={embedstatus} kbId={kb?.id} type={kb?.kb_type} />
        </div>
        <div className="flex w-full items-center gap-2 md:w-auto">
          <Button
            variant="outline"
            size="sm"
            className="gap-2"
            onClick={() => setIsReEmbedOpen(true)}
          >
            <RotateCw className="h-4 w-4" />
            {t('RE_EMBED_BUTTON')}
          </Button>
          <Button
            variant="outline"
            size="sm"
            className="gap-2"
            onClick={() => setIsInfoOpen(!isInfoOpen)}
          >
            <Info className="h-4 w-4" />
            {t('INFO')}
          </Button>
        </div>
      </div>

      <div className="relative flex flex-1 overflow-hidden">
        <div
          className={cn(
            'h-full overflow-y-auto transition-all duration-300 ease-in-out',
            isInfoOpen ? 'w-full xl:w-[75%] xl:pr-4' : 'w-full'
          )}
        >
          <KBDocumentContent kb={kb} />
        </div>

        <KBDocumentInfo kb={kb} open={isInfoOpen} onOpenChange={setIsInfoOpen} />
      </div>

      <ReembedKb
        kbs={[{ id: documentId, type: kb?.kb_type || ('file' as any) }]}
        open={isReEmbedOpen}
        onOpenChange={setIsReEmbedOpen}
        onSuccess={() => setOverrideStatus(EmbeddedStatus.PENDING)}
      />
    </div>
  );
};
